export default () => ({
  subMenuCurrentId: null,
  submenuActiveWidth: 0,
  init() {},
  toggleClick(id) {
    this.subMenuCurrentId === id ? (this.subMenuCurrentId = null) : (this.subMenuCurrentId = id);
  }
});
